import $ from 'jquery';
import BaseClass from '../base/BaseClass';
import Util from '../util/Util';

/**
 * タッチイベント
 * @example
 * const self = this;
 * this.touch = new TouchEventClass();
 * this.touch.onCreate($("#touch_target"),true);
 * this.touch.bind(this.touch.EVENT_TOUCH_START,function(e,d){
 *      self.onTouchStart(e,d);
 * });
 * this.touch.bind(this.touch.EVENT_TOUCH_MOVE,function(e,d){
 *      self.onTouchMove(e,d);
 * });
 * this.touch.bind(this.touch.EVENT_TOUCH_END,function(e,d){
 *      self.onTouchEnd(e,d);
 * });
 * this.touch.addEvent();
 */
export default class TouchEventClass extends BaseClass {
  constructor() {
    super();
    this.name = 'TouchEventClass';

    this.EVENT_TOUCH_START = 'eventTouchStart';
    this.EVENT_TOUCH_MOVE = 'eventTouchMove';
    this.EVENT_TOUCH_END = 'eventTouchEnd';
    this.$target = null;

    this.touchVar = {
      startX: null,
      endX: null,
      startY: null,
      endY: null,
      prevX: null,
      prevX2: null,
      prevY: null,
      prevY2: null,
      diff: null,
      diffX: null,
      diffY: null,
      startAngle: null,
      diffAngle: null,
    };

    this.isEvent = false;
    this.isNotPreventDefault = null;

    this.eventArray = [];
    this.eventArray2 = [];

    this.onTouchListener = this.onTouch.bind(this);
    this.onDragStartListener = this.onDragStart.bind(this);
  }

  onCreate(_target, _isNotPreventDefault) {
    super.onCreate();
    this.$target = _target;
    this.isNotPreventDefault = _isNotPreventDefault;

    if (Util.isTouch) {
      this.eventArray = ['touchstart', 'touchmove', 'touchend'];
    } else if (Util.isPointer) {
      this.eventArray = ['MSPointerDown', 'pointerdown'];
      this.eventArray2 = ['MSPointerMove', 'MSPointerUp', 'pointermove', 'pointerup'];
    } else {
      this.eventArray = ['mousedown'];
      this.eventArray2 = ['mousemove', 'mouseup'];
    }

  }

  addEvent() {
    if (this.isEvent) { return; }
    this.isEvent = true;
    this.addEventListenerTouch(this.$target.get(0), this.eventArray);
  }

  removeEvent() {
    if (!this.isEvent) { return; }
    this.isEvent = false;
    this.removeEventListenerTouch(this.$target.get(0), this.eventArray);
  }

  onTouch(event) {
    let touch = (event.touches) ? event.touches[0] : event;
    // console.log("onTouch",this,event,event.type);

    if (!this.isNotPreventDefault) { event.preventDefault(); }

    if (event.touches) {
      if (event.touches.length >= 2) {
        event.preventDefault();
        return;
      }
    }

    if (event.type === 'mousedown' || event.type === 'MSPointerDown' || event.type === 'pointerdown') {
      this.addEventListenerTouch($(document).get(0), this.eventArray2);
      this.addEventListenerTouch($('html').get(0), ['selectstart', 'dragstart'], this.onDragStartListener);
    } else if (event.type === 'mouseup' || event.type === 'MSPointerUp' || event.type === 'pointerup') {
      this.removeEventListenerTouch($(document).get(0), this.eventArray2);
      this.removeEventListenerTouch($('html').get(0), ['selectstart', 'dragstart'], this.onDragStartListener);
    }

    switch (event.type) {
      case 'touchstart':
      case 'mousedown':
      case 'MSPointerDown':
      case 'pointerdown':
        this.touchVar.diff = this.touchVar.diffX = this.touchVar.diffY = null;
        this.touchVar.startX = this.touchVar.prevX = this.touchVar.prevX2 = this.touchVar.endX = touch.pageX;
        this.touchVar.startY = this.touchVar.prevY = this.touchVar.prevY2 = this.touchVar.endY = touch.pageY;
        this.jq.trigger(this.EVENT_TOUCH_START, { data: this.touchVar, event: event });
        break;
      case 'touchmove':
      case 'mousemove':
      case 'MSPointerMove':
      case 'pointermove':
        this.touchVar.prevX2 = this.touchVar.prevX;
        this.touchVar.prevY2 = this.touchVar.prevY;
        this.touchVar.prevX = this.touchVar.endX;
        this.touchVar.prevY = this.touchVar.endY;
        this.touchVar.endX = touch.pageX;
        this.touchVar.endY = touch.pageY;
        this.touchVar.diffX = this.touchVar.startX - touch.pageX;
        this.touchVar.diffY = this.touchVar.startY - touch.pageY;
        this.jq.trigger(this.EVENT_TOUCH_MOVE, { data: this.touchVar, event: event });
        break;
      case 'touchend':
      case 'mouseup':
      case 'MSPointerUp':
      case 'pointerup':
        this.jq.trigger(this.EVENT_TOUCH_END, { data: this.touchVar, event: event });
        break;
    }
  }

  onDragStart(e) {
    e.preventDefault();
  }

  addEventListenerTouch(_target, _arr, _func) {
    if (!_func) { _func = this.onTouchListener; }
    for (let k in _arr) { _target.addEventListener(_arr[k], _func, { passive: false }); }
  }

  removeEventListenerTouch(_target, _arr, _func) {
    if (!_func) { _func = this.onTouchListener; }
    for (let k in _arr) { _target.removeEventListener(_arr[k], _func, { passive: false }); }
  }

}
